import type {ServiceResponsePayload} from '@igp/shared/api';
import type {CreateRepaymentLogInput, EditRepaymentLogInput, RepaymentLog} from '@igp/shared/contract/pam';
import {createAsyncAction} from 'typesafe-actions';

import type {CreateRepaymentLogPayload, EditRepaymentLogPayload} from './types';

const domain = 'repayment-log';

export const repaymentLogActions = {
    create: createAsyncAction(`${domain}/createRequest`, `${domain}/createSuccess`, `${domain}/createFailure`)<
        CreateRepaymentLogPayload,
        ServiceResponsePayload<CreateRepaymentLogInput, RepaymentLog>,
        ServiceResponsePayload<CreateRepaymentLogInput, RepaymentLog>
    >(),
    edit: createAsyncAction(`${domain}/editRequest`, `${domain}/editSuccess`, `${domain}/editFailure`)<
        EditRepaymentLogPayload,
        ServiceResponsePayload<EditRepaymentLogInput, RepaymentLog>,
        ServiceResponsePayload<EditRepaymentLogInput, RepaymentLog>
    >(),
    remove: createAsyncAction(`${domain}/removeRequest`, `${domain}/removeSuccess`, `${domain}/removeFailure`)<
        string,
        ServiceResponsePayload<string, string>,
        ServiceResponsePayload<string, string>
    >(),
};
